import React, { useContext, useEffect, useCallback } from 'react';
import { Box, Button, MenuItem, TextField, Grid } from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { ChannelContext } from '../../context';
import _debounce from 'lodash/debounce';
import CommonDateRangePicker from '../common/CommonDateRangePicker';
import moment from 'moment/moment';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, allData, setAllPickupRequest } = useContext(ChannelContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const filterData = useCallback(() => {
        const filtered = (allData || []).filter((item) => {
            const val = filters.searchValue?.toLowerCase() || '';
            let matchesSearch = true;

            if (val) {
                if (filters.searchBy === 'channel_name') {
                    matchesSearch = item?.channel_name?.toLowerCase().includes(val);
                } else if (filters.searchBy === 'store_name') {
                    matchesSearch = item?.shopify_store_name?.toLowerCase().includes(val);
                } else {
                    matchesSearch = false;
                }
            }

            let matchesDate = true;
            if (filters.dateRange?.startDate && filters.dateRange?.endDate) {
                const itemDate = moment(item.created_at).startOf('day');
                const start = moment(filters.dateRange.startDate).startOf('day');
                const end = moment(filters.dateRange.endDate).startOf('day');
                // Allow inclusive matching
                matchesDate = itemDate.isSameOrAfter(start) && itemDate.isSameOrBefore(end);
            }

            return matchesSearch && matchesDate;
        });
        setAllPickupRequest(filtered);
    }, [filters, allData, setAllPickupRequest]);

    const debounceFilter = useCallback(_debounce(filterData, 300), [filterData]);

    useEffect(() => {
        debounceFilter();
    }, [filters.searchValue, filters.searchBy, filters.dateRange, debounceFilter]);

    const handleReset = () => {
        setFilters(initialFilters);
        setAllPickupRequest(allData || []);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 4 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem value="channel_name">CHANNEL</MenuItem>
                            <MenuItem value="store_name">STORE NAME</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder="Search by Channel Name..."
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button className="reset-btn" variant="outlined" size="medium" onClick={handleReset}>
                        Reset
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
